export default "__VITE_ASSET__CvzFlwyQ__"